import Button from 'primitive-components/Button';
import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import {
  GeneralLedgerErrorBoundaryContainer,
  GeneralLedgerErrorBoundaryWrapper,
} from './GeneralLedgerErrorBoundary.styles';

const GeneralLedgerErrorFallback = ({
  error,
  resetErrorBoundary,
}: FallbackProps): React.ReactElement => {
  return (
    <GeneralLedgerErrorBoundaryWrapper role="alert">
      <GeneralLedgerErrorBoundaryContainer>
        <p>Oops! Something went wrong:</p>
        <pre>{error.message}</pre>
        <Button onClick={resetErrorBoundary}>Reload</Button>
      </GeneralLedgerErrorBoundaryContainer>
    </GeneralLedgerErrorBoundaryWrapper>
  );
};

export const GeneralLedgerErrorBoundary = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <ErrorBoundary
      FallbackComponent={GeneralLedgerErrorFallback}
      onReset={() => window.location.reload()}
    >
      {children}
    </ErrorBoundary>
  );
};
